import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuCultureTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);

  const getCellData = (key, index) => {
    if (!data || !data[index]) {
      return 'N/A';
    }

    if (key === 'embryologistPerformedIVFICSI') {
      if (!data[index].summary) {
        return 'N/A';
      }
      let embryologist = '';
      if (data[index].summary.isciEmbSign !== '') {
        embryologist = data[index].summary.isciEmbSign;
      }

      if (data[index].summary.inseminationEmbSign !== '') {
        embryologist =
          embryologist === ''
            ? data[index].summary.inseminationEmbSign
            : embryologist + '+ ' + data[index].summary.inseminationEmbSign;
      }
      return embryologist === '' ? 'N/A' : embryologist;
    }

    if (!data[index].oocyteEmbryo) {
      return 'N/A';
    }
    if (key === 'incubator') {
      return data[index].oocyteEmbryo.day0.incubator === ''
        ? 'N/A'
        : data[index].oocyteEmbryo.day0.incubator;
    }

    if (key === 'noOfCleavedEmbryos') {
      const day2 = data[index].oocyteEmbryo.day2.data;
      let count = 0;
      for (let i = 0; i < day2.length; i++) {
        if (day2[i].cell !== 'Not Cleaved') {
          count++;
        }
      }

      return count;
    }

    if (key === 'totalNo2PN') {
      const day1 = data[index].oocyteEmbryo.day1.data;
      let count = 0;
      for (let i = 0; i < day1.length; i++) {
        if (day1[i].pn === '2') {
          count++;
        }
      }
      return count;
    }

    return data[index].oocyteEmbryo[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={4}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            EMBRYO CULTURE DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            Embryologist Performed IVF/ICSI
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>Incubator</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Total No. 2PN</TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}>
            No. of Cleaved Embryos
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={4}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('embryologistPerformedIVFICSI', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('incubator', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('totalNo2PN', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfCleavedEmbryos', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuCultureTable;
